import { getAll } from "@/utilities/querySelector";

const accs = getAll( ".accordion" );
accs.forEach( acc => {
  acc.addEventListener( "click", ( e ) => {
    acc.classList.toggle( "active" );
    const panel = /**@type {HTMLElement} */ ( acc.nextElementSibling );

    if ( acc.classList.contains( 'active' ) ) {
      panel.style.setProperty( 'max-height', `${panel.scrollHeight}px` );
    } else {
      panel.style.setProperty( 'max-height', '' );
    }
  } );
} );